import Vue from "vue";
import Router from "vue-router";
import { auth } from "./plugins/firebase";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/user-management",
      name: "user-management",
      component: () =>
        import(/* webpackChunkName: "UserManagement" */ "./views/UserManagement.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/app-configs",
      name: "app-configs",
      component: () =>
        import(/* webpackChunkName: "AppConfigs" */ "./views/AppConfigs/AppConfigs.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/themes",
      name: "themes",
      component: () =>
        import(/* webpackChunkName: "Themes" */ "./views/Themes/Themes.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/card-pages",
      name: "card-pages",
      component: () =>
        import(/* webpackChunkName: "CardPages" */ "./views/CardPages/CardPages.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":language/:cardPage?",
          name: "card-pages-list",
          component: () =>
            import(/* webpackChunkName: "CardPagesList" */ "./views/CardPages/List.vue")
        },
        {
          path: ":language/:cardPage/items/:id",
          name: "card-page-item",
          component: () =>
            import(/* webpackChunkName: "CardPageItem" */ "./views/CardPages/Item.vue")
        }
      ]
    },
    {
      path: "/list-pages",
      name: "list-pages",
      component: () =>
        import(/* webpackChunkName: "ListPages" */ "./views/ListPages/ListPages.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":language/:listPage?",
          name: "list-pages-list",
          component: () =>
            import(/* webpackChunkName: "ListPagesList" */ "./views/ListPages/List.vue")
        },
        {
          path: ":language/:listPage/items/:id",
          name: "list-page-item",
          component: () =>
            import(/* webpackChunkName: "ListPageItem" */ "./views/ListPages/Item.vue")
        }
      ]
    },
    {
      path: "/content-pages",
      name: "content-pages",
      component: () =>
        import(/* webpackChunkName: "ContentPages" */ "./views/ContentPages/ContentPages.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":language/:contentPage?",
          name: "content-pages-list",
          component: () =>
            import(/* webpackChunkName: "ContentPagesList" */ "./views/ContentPages/List.vue")
        }
      ]
    },
    {
      path: "/notifications/:language",
      name: "notifications",
      component: () =>
        import(/* webpackChunkName: "Notifications" */ "./views/Notifications/Notifications.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/side-menus/:language",
      name: "side-menus",
      component: () =>
        import(/* webpackChunkName: "SideMenus" */ "./views/SideMenus/SideMenus.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/top-menus/:language",
      name: "top-menus",
      component: () =>
        import(/* webpackChunkName: "TopMenus" */ "./views/TopMenus/TopMenus.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bottom-menus/:language",
      name: "bottom-menus",
      component: () =>
        import(/* webpackChunkName: "BottomMenus" */ "./views/BottomMenus/BottomMenus.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/slide-pages/:language/:slidePage?",
      name: "slide-pages",
      component: () =>
        import(/* webpackChunkName: "SlidePages" */ "./views/SlidePages/SlidePages.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, _, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.currentUser) {
      next();
    } else {
      next({
        name: "login",
        query: { nextUrl: to.fullPath },
        replace: true
      });
    }
  } else {
    next();
  }
});

export default router;
